// @ts-nocheck
import React from "react";
import useFetch from "../../../ApiClient/GetApi";
import { faMultiply } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Moment from "react-moment";

export default function Dummy() {
  const { data } = useFetch(
    `booking/booking_detail/${localStorage.getItem("orderId")}`
  );
  
  const liStyle =
    "border border-black font-normal sm:text-base text-xs text-black py-2 sm:px-3 px-1 whitespace-nowrap";

  const tdStyle = "font-normal text-base text-black text-opacity-60 py-2";
  return (
    <>
      {data?.data?.order?.Packages?.map((pack) => (
        <div className="relative xl:w-4/6 lg:w-4/5 w-[96%] left-[50%] -translate-x-[50%] bg-white border border-black">
          <div
            className="border-2 border-black border-opacity-60 float-right 
                rounded-fullest cursor-pointer sm:text-black h-6 w-6 inline-flex 
                justify-center items-center mr-3 mt-3 print:hidden"
            // onClick={closeWaybill}
          >
            <FontAwesomeIcon
              icon={faMultiply}
              className="text-black text-opacity-60"
            />
          </div>
          <div className="my-16 sm:px-8 px-4 py-12 sm:space-y-8 space-y-6 print:my-0 print:py-4">
            <h1
              className="font-medium sm:text-4
            xl text-3xl text-black text-opacity-60 text-center"
            >
              ORDER#{data?.data?.order?.id ?? ""}
            </h1>
            <button
              //   onClick={() => PrintElem(pack.id)}
              className="py-2 px-10 bg-themeBlue text-white rounded border border-themeBlue hover:bg-white hover:text-themeBlue print:hidden"
            >
              Print
            </button>
            <div className="flex items-center sm:gap-x-[33%] gap-x-[20%]">
              <div>
                <img
                  src="images/myOrders/qr.webp"
                  className="md:w-40 sm:w-28 w-20"
                  alt=""
                />
              </div>
              <div className="-translate-x-[20%]">
                <img
                  src="images/logo2.webp"
                  className="md:w-56 sm:w-40 w-32"
                  alt=""
                />
              </div>
            </div>

            <div id={pack.id}>
              <div
                className="flex md:flex-row flex-col md:items-center md:justify-between 
                gap-y-5 overflow-hidden"
              >
                <div className="space-y-2">
                  <p className="font-medium sm:text-base text-sm text-black text-opacity-60 uppercase">
                    Expected Hub Arrival Date :
                    <span className="font-bold text-black">
                      <Moment format="D MMM , YYYY hh:mm a">
                        {data?.data?.order?.expectedHubArrivalDate}
                      </Moment>
                    </span>
                  </p>
                  <p className="font-medium sm:text-base text-sm text-black text-opacity-60 uppercase">
                    Actual Hub Arrival Date:{" "}
                    <span
                      className="relative before:content-[''] before:absolute before:bottom-0 before:left-2 
                      before:w-28 before:h-0.5 before:bg-black"
                    ></span>
                  </p>
                </div>
                <div className="space-y-2">
                  <p className="font-medium sm:text-base text-sm text-black text-opacity-60 uppercase">
                    Expected Consol Numner:{" "}
                    <span className="font-bold text-black">28-11-2022</span>
                  </p>
                  <p className="font-medium sm:text-base text-sm text-black text-opacity-60 uppercase">
                  WayBill No:{" "}
                    <span
                      className="relative before:content-[''] before:absolute before:bottom-0 before:left-2 
                      before:w-36 before:h-0.5 before:bg-black"
                    >{pack.id}</span>
                  </p>
                </div>
              </div>
              <table className="w-full [&>thead>tr>th]:text-start">
                <thead>
                  <tr>
                    <th>DIMENSIONS</th>
                    <td className={tdStyle}>Length (cm)</td>
                    <td className={tdStyle}>Width (cm)</td>
                    <td className={tdStyle}>Height (cm)</td>
                    <td className={tdStyle}>Weight (kg)</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className={tdStyle}>Captured</td>
                    <td className={tdStyle}>{pack.captureLength.toFixed(1)}</td>
                    <td className={tdStyle}>{pack.captureWidth.toFixed(1)}</td>
                    <td className={tdStyle}>{pack.captureHeight.toFixed(1)}</td>
                    <td className={tdStyle}>{pack.captureWeight.toFixed(1)}</td>
                  </tr>
                  <tr>
                    <td className={tdStyle}>Measured</td>
                    <td className={tdStyle}>
                      {pack.measuredLength?.toFixed(1)}
                    </td>
                    <td className={tdStyle}>
                      {pack.measuredWidth?.toFixed(1)}
                    </td>
                    <td className={tdStyle}>
                      {pack.measuredHeight?.toFixed(1)}
                    </td>
                    <td className={tdStyle}>
                      {pack.measuredWeight?.toFixed(1)}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h1 className="font-normal sm:text-2xl text-lg text-themeRed text-center uppercase print:my-2">
                Packages without a waybill attached will not be accepted
              </h1>
              {/* <div>
                <h1 className="font-normal sm:text-xl text-lg uppercase text-white bg-themeGray3 px-5 py-2">
                  Send Packages to below address
                </h1>
                <div
                  className="flex sm:flex-row flex-col sm:justify-between sm:items-center 
                  px-5 py-3 border border-black gap-y-5"
                >
                  <ul className="[&>li]:font-normal [&>li]:text-base sm:space-y-3 space-y-1">
                    <li>
                      {data?.data?.order?.DestinationDetail?.companyName ?? ""}
                    </li>
                    <li>
                      {data?.data?.order?.DestinationDetail?.address ?? ""}
                    </li>
                    <li>
                      {data?.data?.order?.DestinationDetail?.country ?? ""}
                    </li>
                    <li>
                      {data?.data?.order?.DestinationDetail?.city ?? ""}{" "}
                      {data?.data?.order?.DestinationDetail?.province ?? ""}
                    </li>
                    <li>{data?.data?.order?.DestinationDetail?.email ?? ""}</li>
                    <li>{data?.data?.order?.DestinationDetail?.phone ?? ""}</li>
                  </ul>
                </div>
              </div> */}
              <div className="grid md:grid-cols-2 gap-x-5 sm:gap-y-8 gap-y-6 print:flex print:gap-x-5">
                <div className="print:w-1/2">
                  <h1
                    className="font-normal sm:text-xl text-lg uppercase text-white bg-themeGray3 
                    px-3 py-2 border border-black"
                  >
                    Supplier Details
                  </h1>
                  <div className="flex">
                    <ul className="[&>li]:font-normal [&>li]:sm:text-base [&>li]:text-sm">
                      <li className={liStyle}>Tracking No</li>
                      <li className={liStyle}>Name</li>
                      <li className={liStyle}>Email</li>
                      <li className={liStyle}>Number</li>
                    </ul>
                    <ul className="[&>li]:font-normal [&>li]:sm:text-base [&>li]:text-sm w-full">
                      <li className={liStyle}>
                        {data?.data?.order?.SupplierDetail?.trackingNo}
                      </li>
                      <li className={liStyle}>
                        {data?.data?.order?.SupplierDetail?.contactName}
                      </li>
                      <li className={liStyle}>
                        {data?.data?.order?.SupplierDetail?.email}
                      </li>
                      <li className={liStyle}>
                        {data?.data?.order?.SupplierDetail?.phone}
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="print:w-1/2">
                  <h1
                    className="font-normal sm:text-xl text-lg uppercase text-white bg-themeGray3 
                    px-3 py-2 border border-black"
                  >
                    Consignee Details
                  </h1>
                  <div className="flex">
                    <ul className="[&>li]:font-normal [&>li]:sm:text-base [&>li]:text-sm">
                      <li className={liStyle}>Company</li>
                      <li className={liStyle}>Name</li>
                      <li className={liStyle}>Email</li>
                      <li className={liStyle}>Number</li>
                    </ul>
                    <ul className="[&>li]:font-normal [&>li]:sm:text-base [&>li]:text-sm w-full">
                      <li className={liStyle}>
                        {data?.data?.order?.ConsigneeDetail?.companyName}
                      </li>
                      <li className={liStyle}>
                        {data?.data?.order?.ConsigneeDetail?.contactName}
                      </li>
                      <li className={liStyle}>
                        {data?.data?.order?.ConsigneeDetail?.email}
                      </li>
                      <li className={liStyle}>
                        {data?.data?.order?.ConsigneeDetail?.phone}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div>
                <h1
                  className="font-normal sm:text-xl text-lg uppercase text-white bg-themeGray3 px-3 py-2  
                  border border-black print:my-3"
                >
                  Destination Details
                </h1>
                <div className="flex">
                  <ul>
                    <li className={liStyle}>Company</li>
                    <li className={liStyle}>Address</li>

                    <li className={liStyle}>Postal Code</li>
                    <li className={liStyle}>City</li>
                    <li className={liStyle}>Province</li>
                    <li className={liStyle}>Country</li>
                  </ul>
                  <ul className="w-full">
                    <li className={liStyle}>
                      {data?.data?.order?.DestinationDetail?.companyName}
                    </li>
                    <li className={liStyle}>
                      {data?.data?.order?.DestinationDetail?.address}
                    </li>

                    <li className={liStyle}>
                      {data?.data?.order?.DestinationDetail?.postalCode}
                    </li>
                    <li className={liStyle}>
                      {data?.data?.order?.DestinationDetail?.city}
                    </li>
                    <li className={liStyle}>
                      {data?.data?.order?.DestinationDetail?.province}
                    </li>
                    <li className={liStyle}>
                      {data?.data?.order?.DestinationDetail?.country}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
